import PropTypes from 'prop-types';

type MapType = {
  [key: string]: string;
};

export const DROPZONE_SIZES = {
  DEFAULT: 'default',
  SMALL: 'small',
} as MapType;

type Sizes = typeof DROPZONE_SIZES;
export type Size = Sizes[keyof Sizes];

export const sizePropType = PropTypes.oneOf<Size>(
  Object.values(DROPZONE_SIZES)
);
